import { CommonModule } from '@angular/common';
import { Component, HostListener, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ForgotPasswordComponent } from '../../../../../components/auth/forgot-password/forgot-password.component';
import { LoginComponent } from '../../../../../components/auth/login/login.component';
import { OtpComponent } from '../../../../../components/auth/otp/otp.component';
import { RegisterComponent } from '../../../../../components/auth/register/register.component';
import { UpdatePasswordComponent } from '../../../../../components/auth/update-password/update-password.component';
import { Cart } from '../../../../interface/cart.interface';
import { Values } from '../../../../interface/setting.interface';
import { Option } from '../../../../interface/theme-option.interface';
import { AuthService } from '../../../../services/auth.service';
import { CartState } from '../../../../store/state/cart.state';
import { SettingState } from '../../../../store/state/setting.state';
import { ThemeOptionState } from '../../../../store/state/theme-option.state';
import { LoginWithNumberComponent } from '../../../../../components/auth/login-with-number/login-with-number.component';
import { environment } from '../../../../../../../environments/environment';

@Component({
  selector: 'app-login-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule, ReactiveFormsModule, LoginComponent,
    ForgotPasswordComponent, OtpComponent, UpdatePasswordComponent, RegisterComponent, LoginWithNumberComponent],
  templateUrl: './login-modal.component.html',
  styleUrl: './login-modal.component.scss'
})
export class LoginModalComponent {

  @ViewChild("loginModal", { static: true }) LoginModal: TemplateRef<string>;
  @Select(CartState.cartItems) cartItem$: Observable<Cart[]>;
  @Select(SettingState.setting) setting$: Observable<Values>;
  @Select(ThemeOptionState.themeOptions) themeOption$: Observable<Option>;

  public validate: boolean = false;
  public loginForm: FormGroup;
  public closeResult: string;
  public modalOpen: boolean = false;
  public activeForm: string = 'login';
  public storageURL = environment.storageURL;
  public themeOption: Option;
  mobileView: boolean = false;

  constructor(private modalService: NgbModal,
    private authService: AuthService,
    public route: Router,
    public formBuilder: FormBuilder,) {

    this.themeOption$.subscribe(res => this.themeOption = res);

  }
 @HostListener('window:resize', ['$event'])
  onResize() {
    if(window?.innerWidth <= 768){
      this.mobileView = true;
    }else{
      this.mobileView = false;
    }    
  }
  ngAfterViewInit(): void {
    if(this.authService.isLogin === true && this.mobileView){
      this.route.navigate(['/auth'])
    }else if(this.authService.isLogin === true){
      this.openModal()
    }
  }


  nextForm(action: string) {
    this.activeForm = action;
  }

  async openModal() {
    this.modalOpen = true;
    this.modalService.open(this.LoginModal, {
      ariaLabelledBy: 'Login-Modal',
      centered: true,
      windowClass: 'modal-xl modal-dialog-centered auth-modal'
    }).result.then((result) => {
      `Result ${result}`
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: ModalDismissReasons): string {
    this.authService.isLogin = false;
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}
